<template>
  <div id="page-wrap">
    <div class="container">
      <div class="search-header">
        <a>搜索结果：</a>
      </div>
      <div class="tab-content">
        <div class="tab-pane fade in active">
          <div class="mychilidTab-box clearfix">
            <ul class="nav nav-tabs search-tabs">
              <router-link
                :to="{
                  name: 'searchFolder',
                  query: { search: $route.query.search },
                }"
                tag="li"
              >
                <a>文件夹</a>
              </router-link>
              <router-link
                :to="{
                  name: 'searchFile',
                  query: { search: $route.query.search },
                }"
                tag="li"
              >
                <a>文件</a>
              </router-link>
              <router-link
                :to="{
                  name: 'searchGroup',
                  query: { search: $route.query.search },
                }"
                tag="li"
              >
                <a>群组</a>
              </router-link>
            </ul>
            <div class="button-container">
              <a
                class="btn-group-plus"
                data-target="#search-filter"
                data-toggle="modal"
              >
                <i class="ti-filter"></i>
                筛选
                <span class="caret"></span>
              </a>
            </div>
          </div>
          <div class="tab-content clearfix">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchHeader",
  created() {
    this.$store.commit("SET_THEME", "搜索");
  },
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(function () {
      var wh = $(window).height();
      var a = $("#header").height();
      var b = $("#footer").height();
      let c = 0;
      if ($('#noticebox').length > 0) {
        c = $('#noticebox').height();
      }
      $("#page-wrap").css("min-height", wh - a - b - c + "px");
    });
  },
};
</script>

<style scoped>
</style>
